import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AppService } from "src/app/app.service";
import { environment } from "src/environments/environment";
import { BaseService } from "../base/base.service";
import * as CryptoJS from "crypto-js";

@Component({
  selector: "app-manage-profile",
  templateUrl: "./manage-profile.component.html",
  styleUrls: ["./manage-profile.component.css"],
})
export class ManageProfileComponent implements OnInit {
  peopleData: any = [];
  profile_id: any;
  userInfo: any;
  constructor(
    private router: Router,
    private service: AppService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    public baseService: BaseService
  ) {}

  ngOnInit(): void {
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (encryptedData) {
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
          CryptoJS.enc.Utf8
        )
      );
    }
    if (!localStorage.getItem(environment.localStorageKey)) {
      this.router.navigate(["/"]);
    } else {
      this.getpeopleList();
    }
    this.route.queryParams.subscribe((params: any) => {
      this.profile_id = parseInt(params.profile_id);
    });
  }
  getpeopleList() {
    this.spinner.show();
    this.service.getPeopleList().subscribe(
      (res: any) => {
        this.peopleData = res.results;
        this.peopleData.map((el) => {
          el.color = el.color ? el.color : "yellow";
        });
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error(err.error.message, "OOPS!", {
          closeButton: true,
        });
      }
    );
  }
}
